import { render, staticRenderFns } from "./shakeView.vue?vue&type=template&id=704ba652&scoped=true&"
import script from "./shakeView.vue?vue&type=script&lang=js&"
export * from "./shakeView.vue?vue&type=script&lang=js&"
import style0 from "./shakeView.vue?vue&type=style&index=0&id=704ba652&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "704ba652",
  null
  
)

export default component.exports